import { MonitorConfig } from '@/models/store'

export const IdentityTypes = [
  { label: 'Email', value: 'EMAIL' },
  { label: 'Domain', value: 'DOMAIN' },
]

export const monitorConfigDefinitionItems = [
  { name: 'enabled', action: 'Add monitoring to the Cloudwatch dashboard', value: 'Boolean' },
  {
    name: 'minInvocationsCount',
    action: 'Lambda min invocations count',
    value: 'Number',
  },
  { name: 'maxFaultCount', action: 'Lambda max fault count', value: 'Number' },
  {
    name: 'maxLatencyMilliseconds',
    action: 'Lambda max latency milisenconds',
    value: 'Number',
  },
  { name: 'maxErrorCount', action: 'DynamoDB max error count', value: 'Number' },
  {
    name: 'writeThrottledEventsCount',
    action: 'DynamoDB write throttled events count',
    value: 'Number',
  },
]

export const monitorConfigExample: MonitorConfig = {
  lambdas: {
    lambdaAlgoliaStore: {
      enabled: true,
      minInvocationsCount: 1,
      maxFaultCount: 1,
      maxLatencyMillisecond: 300,
    },
    lambdaCognitoTriggerStore: {
      enabled: true,
      minInvocationsCount: 1,
      maxFaultCount: 1,
      maxLatencyMillisecond: 300,
    },
  },
  dynamodb: {
    dynamoDbTableStore: {
      enabled: true,
      maxErrorCount: 1,
      writeThrottledEventsCount: 2,
    },
  },
}
